export enum InventoryColumnKey {
  PRODUCT_UPC_AND_NAME = 'productUpcAndName',
  BRAND_NAME = 'brandName',
  PRODUCT_LOCATION = 'productLocation',
  PRODUCT_CATEGORY = 'productCategory',
  AVAILABLE_AMOUNT = 'availableAmount',
  RESERVED_AMOUNT = 'reservedAmount',
  ON_HAND_AMOUNT = 'onHandAmount',
  PRICE = 'price',
  LAST_UPDATED_DATE = 'lastUpdatedDate',
  STATUS = 'status',
  ACTIONS = 'actions',
}

export enum ProductDetailDataType {
  STRING = 'string',
  NUMBER = 'number',
  COLOR = 'color',
  LOGIC = 'logic',
  DEFAULT = '0',
}

export enum ProductDetailUnit {
  EMPTY = 'empty',
  MM = 'mm',
  CM = 'cm',
  M = 'm',
  G = 'g',
  KG = 'kg',
  L = 'L',
  ML = 'mL',
  OZ = 'oz',
  LB = 'lb',
  M2 = 'm²',
}

export enum InventoryTabKeys {
  general = 'general',
  price = 'price',
  availability = 'availability',
  media = 'media',
  productDetails = 'productDetails',
  variants = 'Variants',
}

export enum AvailabilityColumnKey {
  LOCATION = 'location',
  ON_HAND = 'onHand',
  RESERVED = 'reserved',
  INCOMING = 'incoming',
  AVAILABLE = 'available',
}

export enum ProductDetailsEnum {
  NAME = 'name',
  TYPE = 'type',
  UNIT = 'unit',
  VALUE = 'value',
}
